module.exports = __webpack_public_path__ + "static/img/报告查询@3x.c01b5c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/报告查询@3x.png
// module id = 312
// module chunks = 363 364